
























































































import Vue from 'vue';
import { errorToMessage } from '@/core/utils/errors';
import { mapGetters } from 'vuex';
import { getStudentViewURL } from '@/web/router/custom-domain-utils';

export default Vue.extend({
  name: 'CommunityMembersModal',
  computed: {
    ...mapGetters({
      teacherStudioUrl: 'user/teacherStudioUrl',
      teacherMagicCode: 'user/teacherMagicCode',
      isStudioOwner: 'user/isStudioOwner',
      currentUser: 'user/user',
    }),
    query(): {} {
      return {
        q: this.search,
        groupId: this.group.id,
      };
    },
  },
  props: {
    group: {
      type: Object as () => CommunityGroupsResponse,
      required: true,
    },
  },
  data() {
    return {
      isLoading: true,
      search: '',
      members: [],
      tableFields: [
        {
          name: 'name',
          title: this.$t('COMMUNITY.TABLE.NAME'),
        },
        {
          name: 'status',
          title: this.$t('COMMUNITY.TABLE.STATUS'),
        },
        {
          name: 'actions',
          title: '',
        },
      ],
      numMembers: null,
    };
  },
  methods: {
    async onDiscard() {
      if (this.discard) {
        await this.discard();
      }
      await this.$emit('close');
    },
    async banMember(groupId, member) {
      try {
        await this.$store.dispatch('community/banMember', {
          groupId,
          memberId: member.id,
        });
        member.is_banned = true;
        this.group.num_members -= 1;
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t(
            'COMMUNITY.NOTIFICATIONS.MEMBER_WAS_SUCCESSFULLY_BANNED'
          ),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR') as string,
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1,
        });
      }
    },
    async unBanMember(groupId, member) {
      try {
        await this.$store.dispatch('community/unBanMember', {
          groupId,
          memberId: member.id,
        });
        member.is_banned = false;
        this.group.num_members += 1;
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t(
            'COMMUNITY.NOTIFICATIONS.MEMBER_WAS_SUCCESSFULLY_UNBANNED'
          ),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR') as string,
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1,
        });
      }
    },
    viewProfile(data) {
      const route = this.$router.resolve({
        name: 'student-community-profile-view',
        params: {
          id: data.id,
          studio_url: this.teacherStudioUrl,
        },
      });
      const routeUrl = route.href.replaceAll(`${this.teacherStudioUrl}/`, '');
      const url = getStudentViewURL(
        this.teacherStudioUrl,
        routeUrl,
        this.teacherMagicCode
      );
      window.open(url, '_blank');
    },
    getStatus(value): string {
      return value.is_banned
        ? this.$t('COMMUNITY.TEXT.BANNED')
        : value.is_admin
        ? this.$t('COMMUNITY.TEXT.ADMIN')
        : this.$t('COMMUNITY.TEXT.MEMBER');
    },
    getCircleClass(value) {
      return value.is_banned
        ? 'status--banned'
        : value.is_admin
        ? 'status--admin'
        : 'status--member';
    },
    canBanUser(data) {
      return (
        !data.is_admin ||
        (this.isStudioOwner && data.id != this.currentUser.community_profile_id)
      );
    },
  },
});
